import type { ValueOf } from '../util/typeUtils';

export const TEAM_COMMANDS = {
    addLeader: 'addLeader',
    addUser: 'addUser',
    create: 'create',
    deactivate: 'deactivate',
    removeLeader: 'removeLeader',
    removeUser: 'removeUser',
    rename: 'rename',
    setCategory: 'setCategory',
} as const;

export type TEAM_COMMAND = ValueOf<typeof TEAM_COMMANDS>;
